
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M13.0001 10.17L10.5001 7.67V2.25C10.5001 1.56 11.0601 1 11.7501 1C12.4401 1 13.0001 1.56 13.0001 2.25V10.17ZM20.0001 5.32C20.0001 4.67 19.5301 4.07 18.8801 4C18.1301 3.92 17.5001 4.51 17.5001 5.24V10.49C17.5001 10.77 17.2801 10.99 17.0001 10.99C16.7201 10.99 16.5001 10.77 16.5001 10.49V3.31C16.5001 2.66 16.0301 2.06 15.3801 1.99C14.6301 1.93 14.0001 2.52 14.0001 3.25V11.17L20.0001 17.17V5.32ZM9.50012 4.25C9.50012 3.56 8.94012 3 8.25012 3C7.58012 3 7.05012 3.53 7.01012 4.18L9.50012 6.67V4.25ZM17.0001 22C17.6201 22 18.1801 21.81 18.6501 21.48L18.6301 21.46L19.0701 21.9C19.4601 22.29 20.0901 22.29 20.4801 21.9C20.8701 21.51 20.8701 20.88 20.4801 20.49L3.51012 3.51C3.12012 3.12 2.49012 3.12 2.10012 3.51C1.71012 3.9 1.71012 4.53 2.10012 4.92L7.02012 9.84L7.00012 9.83V14.13L4.40012 12.65C4.23012 12.56 4.06012 12.51 3.86012 12.51C3.60012 12.51 3.36012 12.6 3.16012 12.77L2.00012 13.88L8.80012 21.06C9.37012 21.66 10.1501 22 10.9801 22H17.0001Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-do-not-touch`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconDoNotTouch

    ```js
    <b-new-b-icon-do-not-touch />
    ```
</docs>


